import { EventEmitter, Injectable, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { IResponseModel } from 'src/app/Shared/models/ProspectModel';
@Injectable({
  providedIn: 'root'
})
export class DataService {
  @Output() notiOnlineReservationEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() azureSearchEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() searchGridViewEmitter: EventEmitter<any> = new EventEmitter<any>();
  public callGetNotficationCountEmitter = new Subject<boolean>();
  public notificationRouteEmitter = new Subject<boolean>();
  public onlineResNotificationRouteEmitter = new Subject<boolean>();
  public onlineInqNotificationRouteEmitter = new Subject<boolean>();
  public tempInsuranceLabel;
  public storage: any;
  public custimerInfoStorage: any;
  public followUpsData: any;
  public MoveOutData: any;
  public ActionData: any;
  public InquiryDetails: any;
  public ReservationDetails: any;
  public dashfollowup: any;
  public notification: any;
  public selectedLease: number;
  public IsfromProspectListing: any;
  public Unitavailability: any
  public Unitinfo: any;
  public unitlock: any;
  public modifyautopay: any;
  public isWalkinCustomer = false;
  public blacklist: any;
  public customerUnitRentalList: any;
  public dayEndData;
  public miscellaneousSettings;
  public fromAzureSearch: any;
  public searchResult;
  public notificationToRefundReversal: any = {};
  public CustomerLateAndLienSetting = [];
  public unitLeaseStatusInfo = null;
  public ProspectFilterId: any;
  public SelectedFilter: any;
  public invoiceSettingsApiInfo: any;
  public dashboadNoData: any;
  public notificationToMerchRefund: any = {};
  public facilityGateSystemResponse: IResponseModel;
  public facilityGateDetails: any;
  public smsLogsPopup: boolean = false;
  public emailLogsPopup: boolean = false;
  constructor() { }
  clearData() {
    this.storage = {};
    this.custimerInfoStorage = {};
    this.followUpsData = {};
    this.MoveOutData = {};
    this.ActionData = {};
    this.InquiryDetails = {};
    this.ReservationDetails = {};
    this.dashfollowup = {};
    this.notification = {};
    this.IsfromProspectListing = {};
    this.Unitavailability = {};
    this.Unitinfo = {};
    this.unitlock = {};
    this.modifyautopay = {};
    this.isWalkinCustomer = false;
    this.customerUnitRentalList = {};
    this.tempInsuranceLabel = null;
    this.searchResult = {};
    this.notificationToRefundReversal = {};
    this.CustomerLateAndLienSetting = [];
    this.unitLeaseStatusInfo = null;
    this.invoiceSettingsApiInfo = null;
    this.facilityGateSystemResponse = null;
    this.facilityGateDetails = null;
  }
}
